/* Wraps every "®" text occurrence in <sup> so the mark renders superscript
   site-wide, including merchant-authored content. Idempotent; re-runs on DOM
   swaps (recipe changes, drawers) via a debounced MutationObserver. */

(function () {
  if (window.__superscriptMarksBound) return;
  window.__superscriptMarksBound = true;

  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, INPUT: 1, SELECT: 1, SUP: 1 };

  var wrapMarks = function (root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (node.nodeValue.indexOf('®') === -1) return NodeFilter.FILTER_REJECT;
        for (var el = node.parentElement; el; el = el.parentElement) {
          if (SKIP_TAGS[el.tagName]) return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });

    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);

    nodes.forEach(function (node) {
      var parts = node.nodeValue.split('®');
      var frag = document.createDocumentFragment();
      parts.forEach(function (part, i) {
        if (part) frag.appendChild(document.createTextNode(part));
        if (i < parts.length - 1) {
          var sup = document.createElement('sup');
          sup.className = 'registered-mark';
          sup.textContent = '®';
          frag.appendChild(sup);
        }
      });
      node.parentNode.replaceChild(frag, node);
    });
  };

  var timer = null;
  var observer = null;

  var run = function () {
    if (observer) observer.disconnect();
    wrapMarks(document.body);
    if (observer) observer.observe(document.body, { childList: true, subtree: true });
  };

  var schedule = function () {
    clearTimeout(timer);
    timer = setTimeout(run, 150);
  };

  var idle = window.requestIdleCallback || function (cb) { return setTimeout(cb, 1); };

  var start = function () {
    observer = new MutationObserver(schedule);
    idle(run);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
